import { axiosV2 } from 'interceptors/axios';

import { decryptResponse } from 'utils/token';

type DeleteNoteProps = {
  noteId: string;
};

export const deleteNote =
  ({ noteId }: DeleteNoteProps) =>
  async () => {
    const { data } = await axiosV2.delete(`/notes/${noteId}`);

    const decodedData = await decryptResponse(data);

    return decodedData;
  };
